import {GeoPosition} from '../../locations/domains/geo-position';
import {GeoLocality} from '../../locations/domains/geo-locality';

export class GetUserCurrentPositionAction {
  static readonly type = '[UserLocation] GetUserCurrentPositionAction';
}


export class DecodeUserFromLatLngAction {
  static readonly type = '[UserLocation] DecodeUserFromLatLngAction';
}


export class SetUserLocationAction {
  static readonly type = '[UserLocation] SetUserLocationAction';

  constructor(public payload: { locality: GeoLocality; position: GeoPosition }) {

  }
}

export class SetRedirectPageAfterSelectedLocationAction {
  static readonly type = '[UserProfile] SetRedirectPageAfterSelectedLocationAction';

  constructor(public readonly route: string) {
  }
}

export class ResetRedirectPageAfterSelectedLocationAction {
  static readonly type = '[UserProfile] ResetRedirectPageAfterSelectedLocationAction';

}
